import "core-js/modules/es6.array.find";
import "core-js/modules/es6.function.name";
import _regeneratorRuntime from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/opter/repo/code/cloudsee-web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import repo from '@/api/basic-setting/icons';

/**
 * 选择系统图标
 */
export default {
  data: function data() {
    return {
      name: null,
      iconList: [],
      filterList: []
    };
  },
  created: function created() {
    this.initData();
  },
  methods: {
    initData: function () {
      var _initData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return repo.getSystemIcons();
            case 2:
              this.iconList = _context.sent;
              this.$nextTick(function () {
                _this.searchIconByName();
                _this.$emit('ready', _this.iconList);
              });
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function initData() {
        return _initData.apply(this, arguments);
      }
      return initData;
    }(),
    searchIconByName: function searchIconByName() {
      var _this2 = this;
      if (this.name) {
        this.filterList = this.iconList.filter(function (item) {
          return item.name.indexOf(_this2.name) > -1;
        });
      } else {
        this.filterList = this.iconList;
      }
    },
    findIconByUrl: function findIconByUrl(url) {
      var defaultIcon = {
        name: null,
        url: null
      };
      if (!url) {
        return defaultIcon;
      }
      var hitIcon = this.iconList.find(function (item) {
        return item.url === url;
      });
      return hitIcon || defaultIcon;
    },
    onSelectIcon: function onSelectIcon(item) {
      this.$emit('select', item);
      document.body.click();
    }
  }
};